export default function MyLeads() {
  return <div>My Leads</div>;
}
